// extracted by mini-css-extract-plugin
export default {"navItem":"index_navItem__23Y-z typography_bodyFont__3RHTp","active":"index_active__1dqNh"};